import { useAuth } from "@/context/AuthContext";
import { Clock, Mail } from "lucide-react";

export default function TrialBanner() {
  const { user } = useAuth();
  if (!user?.trial || user.trial_expired) return null;
  const days = user.trial_days_left;
  return (
    <div data-testid="trial-banner" className="border-b border-primary/30 bg-primary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-9 flex items-center justify-between gap-3 text-xs sm:text-sm">
        <p className="flex items-center gap-2 text-slate-100 truncate">
          <Clock className="w-3.5 h-3.5 text-primary shrink-0" />
          <span className="font-medium text-primary" data-testid="trial-days-left">Free trial · {days} day{days === 1 ? "" : "s"} left</span>
          <span className="hidden sm:inline text-slate-300">· Documents Blocks 1–3 + Mid-Unit Task Test</span>
        </p>
        <a data-testid="trial-banner-contact" href={`mailto:${user.trial_contact}?subject=${encodeURIComponent("HorizonQuest — unlock the full app")}`}
          className="inline-flex items-center gap-1.5 text-primary hover:underline shrink-0">
          <Mail className="w-3.5 h-3.5" /> Unlock everything
        </a>
      </div>
    </div>
  );
}
